// @flow
export const LINK_THEME_API = {
  root: '',
  underlined: '',
  underlinedOnHover: '',
  withIconAfter: '',
  withIconBefore: '',
};
